'use client';

import { c as _c } from "react/compiler-runtime";
import { runInStories } from './_data';
export function RunInBoard() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-8 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]"><div><p className="text-sm font-black text-[#8a3f31] uppercase">The final stretch</p><h2 className="font-sans text-5xl font-semibold">Three gameweeks left. Plenty of time to get cooked.</h2></div><p className="text-lg leading-8 font-semibold text-[#5f5364]">The 7 Down are still within five points of each other, which means relegation roulette is live. The title race remains Rohit's to fumble. The basement smells like paperwork and an open mic set.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="fantasy-reveal mx-auto max-w-7xl px-5 py-16 sm:px-8">{t0}<div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">{runInStories.map(_temp)}</div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(story) {
  return <article key={story.title} className="border border-[#24122f] bg-[#fffaf1] p-5 shadow-[6px_6px_0_#d7c9b7]"><p className="font-sans text-5xl font-black text-[#4f6f3b]">{story.stat}</p><h3 className="mt-4 font-sans text-2xl font-semibold">{story.title}</h3><p className="mt-3 text-sm leading-6 font-semibold text-[#514458]">{story.body}</p></article>;
}